/** Share an optional download and allow a failed download to be retried. */
let pending;
export function loadWhiteboard() {
    if (!pending) {
        pending = import(/* webpackChunkName: "whiteboard" */ '@jitsi/excalidraw').catch(error => {
            pending = undefined;
            throw error;
        });
    }
    return pending;
}
